export default "__VITE_ASSET__CpMVr9R3__"